import { __extends } from "tslib";
import { TouchCamera } from "./touchCamera";
import { Node } from "../node";
import { Vector3 } from "../Maths/math.vector";
import { Camera } from "./camera";
import "../Gamepads/gamepadSceneComponent";
Node.AddNodeConstructor("FreeCamera", function (name, scene) {
    // Forcing to use the Universal camera
    return function () { return new UniversalCamera(name, Vector3.Zero(), scene); };
});
/**
 * The Universal Camera is the one to choose for first person shooter type games, and works with all the keyboard, mouse, touch and gamepads. This replaces the earlier Free Camera,
 * which still works and will still be found in many Playgrounds.
 * @see https://doc.babylonjs.com/features/cameras#universal-camera
 */
var UniversalCamera = /** @class */ (function (_super) {
    __extends(UniversalCamera, _super);
    /**
     * The Universal Camera is the one to choose for first person shooter type games, and works with all the keyboard, mouse, touch and gamepads. This replaces the earlier Free Camera,
     * which still works and will still be found in many Playgrounds.
     * @see https://doc.babylonjs.com/features/cameras#universal-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     */
    function UniversalCamera(name, position, scene) {
        var _this = _super.call(this, name, position, scene) || this;
        _this.inputs.addGamepad();
        return _this;
    }
    Object.defineProperty(UniversalCamera.prototype, "gamepadAngularSensibility", {
        /**
         * Defines the gamepad rotation sensiblity.
         * This is the threshold from when rotation starts to be accounted for to prevent jittering.
         */
        get: function () {
            var gamepad = this.inputs.attached["gamepad"];
            if (gamepad) {
                return gamepad.gamepadAngularSensibility;
            }
            return 0;
        },
        set: function (value) {
            var gamepad = this.inputs.attached["gamepad"];
            if (gamepad) {
                gamepad.gamepadAngularSensibility = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UniversalCamera.prototype, "gamepadMoveSensibility", {
        /**
         * Defines the gamepad move sensiblity.
         * This is the threshold from when moving starts to be accounted for for to prevent jittering.
         */
        get: function () {
            var gamepad = this.inputs.attached["gamepad"];
            if (gamepad) {
                return gamepad.gamepadMoveSensibility;
            }
            return 0;
        },
        set: function (value) {
            var gamepad = this.inputs.attached["gamepad"];
            if (gamepad) {
                gamepad.gamepadMoveSensibility = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets the current object class name.
     * @return the class name
     */
    UniversalCamera.prototype.getClassName = function () {
        return "UniversalCamera";
    };
    return UniversalCamera;
}(TouchCamera));
export { UniversalCamera };
Camera._createDefaultParsedCamera = function (name, scene) {
    return new UniversalCamera(name, Vector3.Zero(), scene);
};
//# sourceMappingURL=universalCamera.js.map